import { render, staticRenderFns } from "./ActionsExpansionPanel.vue?vue&type=template&id=545fa5de"
import script from "./ActionsExpansionPanel.vue?vue&type=script&lang=ts"
export * from "./ActionsExpansionPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports